import { useContext } from 'react';
import { ExternalSalesModalKeys } from 'pages/external-sales/constants/constants';
import { DeleteModal, ModalContext } from 'dash-ui';

import {
  GetSaleTeamsDocument,
  useDeleteSaleTeamMutation,
} from 'gql/generated.graphql';

const DeleteExternalSaleTeamModal = () => {
  const { payload } = useContext(ModalContext);
  const { original, refetch } = payload || {};
  const [deleteSaleTeam, { loading }] = useDeleteSaleTeamMutation({
    refetchQueries: [GetSaleTeamsDocument],
    onCompleted: () => {
      refetch();
    },
  });

  const onSubmit = async () => {
    await deleteSaleTeam({
      variables: { saleTeamId: original?._id },
    });
  };

  return (
    <DeleteModal
      w={470}
      entity="External Sale Team"
      name={original?.name || ''}
      isLoading={loading}
      modalName={ExternalSalesModalKeys.DeleteExternalSaleTeamUser}
      onClick={onSubmit}
      colorVariation="danger"
    />
  );
};

export default DeleteExternalSaleTeamModal;
